import { render, staticRenderFns } from "./CopyFromFloorSource.vue?vue&type=template&id=1ccbb325&scoped=true&lang=pug&"
import script from "./CopyFromFloorSource.vue?vue&type=script&lang=js&"
export * from "./CopyFromFloorSource.vue?vue&type=script&lang=js&"
import style0 from "./CopyFromFloorSource.vue?vue&type=style&index=0&id=1ccbb325&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ccbb325",
  null
  
)

export default component.exports